import { render, staticRenderFns } from "./InboundLabelPrint.vue?vue&type=template&id=119b31d8"
import script from "./InboundLabelPrint.vue?vue&type=script&lang=js"
export * from "./InboundLabelPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports